import React from "react";
import { Icon } from "@ddm-design-system/icon";
import useIsMobile from "../../hooks/useIsMobile";
import background from "../../assets/dm.jpeg";
import StyleConstants from "../../constants";
import Onboarding from "./Onboarding";

export const FirstLogin: React.FC = () => {
  const isMobile = useIsMobile(StyleConstants.mobileBreakpoint2);

  return (
    <div className="login-page">
      {!isMobile && (
        <div className="login-background">
          <div className="login-background-image instant center full-logo frame">
            <img src={background} alt="background" />
            <div className="logo-container">
              <Icon name="dm-full-logo" fill="var(--color-white)" />
            </div>
          </div>
        </div>
      )}
      <div className="login-form">
        <div className="login-lower">
          <Onboarding />
        </div>
      </div>
    </div>
  );
};

export default FirstLogin;
